import base from './configService'

const fechaHoraServerServices = {}

fechaHoraServerServices.getFechaHoraActualServer = function (id) {
    return base.get('/FechaHoraActual?v=' + (Math.ceil(Math.random()*1000000)).toString())
      .then(res => {
        return res.data;
      })
      .catch(e => {
        return Promise.reject(e);
      })
}

export default fechaHoraServerServices